import { Route } from "react-router-dom";
import CSelabld from "../pages/team/csebald";
import Lehrpraxis from "../pages/team/lehrpraxis";


const TeamRoutes = [
    <Route path="/team/csebald" element={<CSelabld />}/>,
    <Route path="/team/lehrpraxis" element={<Lehrpraxis />}/>
]
    
export default TeamRoutes;
